import script from "./programPage.vue?vue&type=script&setup=true&lang=js"
export * from "./programPage.vue?vue&type=script&setup=true&lang=js"

import "./programPage.vue?vue&type=style&index=0&id=7f91560c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7f91560c"]])

export default __exports__